import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/news',
    component: LAYOUT,
    redirect: '/news/index',
    meta: { title: '新闻中心', showNavPanel: true },
    children: [
      {
        path: 'index',
        name: '新闻中心',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '新闻中心', hide: true, showNavPanelBorder: false },
      },
      {
        path: 'news',
        name: '总会快递',
        component: () => import('@/views/news/news.vue'),
        meta: { title: '总会快递' },
      },
      {
        path: 'schoolNews',
        name: '校友信息',
        component: () => import('@/views/news/schoolNews.vue'),
        meta: { title: '校友信息' },
      },
      {
        path: 'areaActivity',
        name: '地区活动',
        component: () => import('@/views/news/areaActivity.vue'),
        meta: { title: '地区活动' },
      },
      {
        path: 'collegesActivity',
        name: '院系活动',
        component: () => import('@/views/news/collegesActivity.vue'),
        meta: { title: '院系活动' },
      },
      {
        path: 'businessNews',
        name: '行业兴趣',
        component: () => import('@/views/news/businessNews.vue'),
        meta: { title: '行业兴趣' },
      },
    ],
  },
]
